import { useState, type FormEvent } from 'react';
import { subscribeHooks } from '@/mocks/home';

export default function Subscribe() {
  const [done, setDone] = useState(false);
  const [tip, setTip] = useState('');

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setTip('已加入猛料提醒队列，压轴档更新时会第一时间通知你。');
    setDone(true);
  };

  return (
    <section id="subscribe" className="relative w-full overflow-hidden bg-background-950 py-14 md:py-20">
      <div className="pointer-events-none absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20crimson%20and%20amber%20glowing%20waves%20and%20light%20streaks%20flowing%20over%20near%20black%20background%2C%20energetic%20editorial%20broadcast%20backdrop%2C%20cinematic%20atmosphere%2C%20film%20grain%2C%20high%20contrast%2C%20dynamic%20composition&width=1800&height=700&seq=subscribe-bg-2026&orientation=landscape"
          alt="订阅黑料王猛料"
          className="h-full w-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/85 to-background-950/60" />
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-500/40 bg-primary-500/10 px-3 py-1 text-xs font-semibold text-primary-300">
            <i className="ri-mail-star-line" /> 一手猛料
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black leading-snug text-background-50 md:text-4xl">
            订阅黑料王
            <br />
            <span className="text-accent-400">压轴高能</span>第一时间送到
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/75 md:text-base">
            不再错过任何一段劲爆细节。大瓜上架、辟谣落地、名场面复盘，我们都帮你盯好。
          </p>

          {done ? (
            <div className="mt-7 flex items-center gap-3 rounded-md border border-accent-400/40 bg-accent-500/15 px-5 py-4 text-sm font-medium text-accent-200">
              <i className="ri-checkbox-circle-fill text-xl text-accent-400" />
              {tip}
            </div>
          ) : (
            <form
              className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
              onSubmit={onSubmit}
            >
              <input
                type="email"
                name="email"
                required
                placeholder="输入邮箱，接收黑料王猛料与大瓜精选"
                className="h-12 flex-1 rounded-md border border-background-50/15 bg-background-50/5 px-4 text-sm text-background-50 outline-none backdrop-blur placeholder:text-background-200/50 focus:border-accent-400"
              />
              <button
                type="submit"
                className="h-12 whitespace-nowrap cursor-pointer rounded-md bg-primary-500 px-6 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                立即订阅
              </button>
            </form>
          )}
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-lg border border-background-50/10 bg-background-50/5 p-6 backdrop-blur md:p-8">
            <h3 className="text-sm font-bold text-background-50">为什么订阅？</h3>
            <ul className="mt-5 space-y-4">
              {subscribeHooks.map((hook) => (
                <li key={hook} className="flex items-start gap-3 text-sm text-background-100/80">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500/20 text-accent-400">
                    <i className="ri-check-line" />
                  </span>
                  {hook}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-center gap-2 rounded-md bg-background-50/5 px-3 py-2.5 text-xs text-background-200/60">
              <i className="ri-shield-check-line text-accent-400" />
              仅用于推送，可随时退订，黑料王承诺不骚扰。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}